export var vipProgramLevelToVp = [0, 300, 1000, 2500, 5000, 10000, 25000, 50000, 100000];
